import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ConfirmDialog from 'components/Dialog/Confirm';
import {getURL} from '../../routes';
import {
  changepasswordAPI
} from "actions/AuthActions";

class ChangePwdPanel extends Component {
  state = {
    oldPwd: "",
    newPwd: "",
    newPwdErr: false,
    confirmPwd: "",
    confirmPwdErr: false
  }

  handleChangePassword = () => {
    let {oldPwd, newPwd, newPwdErr, confirmPwd, confirmPwdErr} = this.state;

    if (newPwdErr || confirmPwdErr) return 
    
    if (newPwd !== confirmPwd){
      alert("新密碼與確認密碼不一致");
      return 
    }
    
    changepasswordAPI(oldPwd, newPwd)
      .then((response) => {
        if (response.data.success)
          alert("更改成功");
        else
          throw new Error('error');
      })
      .catch((error) => {
        alert("更改失敗");
      })
  }

  tryChange = () => {
    ConfirmDialog("將修改密碼")
      .then(
        () => {this.handleChangePassword()},
        () => {},
      )
  }

  handleChange = (e) => {
    let {name, value} = e.target;
    let validation = {};
    if (name === 'newPwd' || name === 'confirmPwd') {
      validation[name + "Err"] = (value.length < 8)
    }

    this.setState({
      [name]: value,
      ...validation
    });
  }

  render() {
    let {oldPwd, newPwd, newPwdErr, confirmPwd, confirmPwdErr} = this.state;
    return (
      <div className="password-panel setting-panel">
        <div className="setting-header">
          <button
            className="btn btn-default"
            onClick={()=>{this.props.dispatch(push(getURL('ws-admin/setting')))}}>
            返回
          </button>
          <button className="btn btn-primary pull-right" onClick={this.tryChange}>
            儲存
          </button>
        </div>
        <div className="form-group">
          <label className="col-xs-2 col-xs-offset-2 control-label">舊密碼</label>
          <div className="col-xs-6">
            <input
              type="password"
              className="form-control"
              name="oldPwd" 
              value={oldPwd}
              onChange={this.handleChange} />
          </div>
        </div>
        <div className={"form-group" + (newPwdErr? " has-error": "")}>
          <label className="col-xs-2 col-xs-offset-2 control-label">新密碼</label>
          <div className="col-xs-6">
            <input
              type="password"
              className="form-control"
              name="newPwd"
              value={newPwd}
              onChange={this.handleChange} />
          </div>
        </div>
        <div className={"form-group" + (confirmPwdErr? " has-error": "")}>
          <label className="col-xs-2 col-xs-offset-2 control-label">確認新密碼</label>
          <div className="col-xs-6">
            <input
              type="password"
              className="form-control"
              name="confirmPwd"
              value={confirmPwd}
              onChange={this.handleChange} />
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state) => ({
}))(ChangePwdPanel);


// WEBPACK FOOTER //
// ./src/components/Setting/ChangePwdPanel.js